<template>
  <div class="mt-4 mx-1">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/admin/dashboard' }"
          >管理中心
        </el-breadcrumb-item>
        <el-breadcrumb-item>文章内容</el-breadcrumb-item>
        <el-breadcrumb-item
          ><span class="text-primary">专题文章</span></el-breadcrumb-item
        >
      </el-breadcrumb>
    </el-row>
    <el-card class="my-4 mx-1">
      <el-table
        ref="multipleTable"
        :data="articleList"
        tooltip-effect="dark"
        style="width: 100%;min-height: 500px"
        stripe
        v-loading="loading"
        element-loading-text="拼命加载中"
      >
        <el-table-column
          prop="articleId"
          label="文章ID"
          sortable
          align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column prop="articleTitle" label="文章名称" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center">
        </el-table-column>
        <el-table-column prop="updateTime" label="修改时间" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right">
          <template slot-scope="scope">
            <!--suppress JSUnresolvedVariable -->
            <el-button
              @click="editArticle(scope.row.articleId)"
              type="primary"
              plain
              size="small"
              icon="el-icon-edit"
              :disabled="
                !adminPermissions.includes('/article/admin/updateArticle')
              "
              >编辑
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
export default {
  name: "Article",
  data() {
    return {
      articleList: [],
      adminPermissions: this.$store.state.adminPermissions,
      loading: false
    };
  },
  mounted() {
    this.getArticleList();
  },
  methods: {
    getArticleList() {
      this.loading = true;
      this.axios.get("/article/admin/getArticleList").then(resp => {
        if (resp && resp.data.code === 10000 && resp.data.success) {
          this.articleList = resp.data.data;
          this.loading = false;
        }
      });
    },
    editArticle(articleId) {
      this.$router
        .push({ name: "ArticleForm", params: { articleId: articleId } })
        .catch();
    }
  }
};
</script>

<style scoped></style>
